import React from 'react'
import styled from 'styled-components'

function InputContainer({ children }) {


    return (
        <div  className='flex flex-col p-3 gap-3 my-3'>
            {children}
        </div>
    )
}

export default InputContainer